export function getJob(jobId) {
    let { getJobRequest, getJobError, getJobResult } = this.props

    this.doAction(this.WEB_REQUEST_URL + 'get_job', this.createBundle('get_job', { jobId }, this.GET, getJobRequest, getJobResult, getJobError))
}
